// Store
import { axiosInstance } from './index'
import imageCompression from 'browser-image-compression'
const basePath = '/kyc'

export const getKYCFieldsListAPI = async () => {
  const response = await axiosInstance.get(`${basePath}/fields`)
  // console.log('onGetKYCFieldsListAPI response.data', response.data)
  return response.data
}

export const sendKYCFieldAPI = async ({ name, file }) => {
  const options = {
    maxSizeMB: 1,               // не больше 1 МБ
    maxWidthOrHeight: 1024,     // не больше 1024px по ширине/высоте
    useWebWorker: true          // в Web Worker, чтобы не блокировать UI
  }

  const compressedFile = await imageCompression(file, options)

  const formData = new FormData()
  formData.append('name', name)
  formData.append('file', compressedFile, file.name)

  const response = await axiosInstance.post(basePath, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  // console.log('sendKYCFieldAPI response.data', response.data)
  return response.data
}

export const deleteKYCFieldAPI = async ({ name }) => {
  const response = await axiosInstance.delete(basePath, {
    params: { name },
  })
  // console.log('sendKYCFieldAPI response.data', response.data)
  return response.data
}
